import { VariationTypes } from './variationTypes';

type ValueOf<T> = T[keyof T];

export type FeatureFlag = {
  // Determines whether the feature flag is sent to Fullstory as a user property
  fullstoryEnabled?: boolean;
  name: string;
  variationType: ValueOf<typeof VariationTypes>;
};

// Names must match the feature flag names in Optimizely
export const FeatureFlags = {
  BFA_CALL_UPDATE_BILLING_STATUS: {
    fullstoryEnabled: true,
    name: 'bfa_call_update_billing_status',
    variationType: VariationTypes.ROLLOUT,
  },
  BFI_FRAUD_SCORE_GATE_API_KEY_GENERATION: {
    fullstoryEnabled: true,
    name: 'bfi_fraud_score_gate_api_key_generation',
    variationType: VariationTypes.ROLLOUT,
  },
  DHL_GERMANY_SUPPORT_DEPRECATED: {
    fullstoryEnabled: true,
    name: 'carrier_support_deprecated',
    variationType: VariationTypes.ROLLOUT,
  },
  FEDEX_NEW_API_ENABLED: {
    fullstoryEnabled: true,
    name: 'fedex_new_api_enabled_ui',
    variationType: VariationTypes.ROLLOUT,
  },
  INTELLIGENCE_ADMIN: {
    fullstoryEnabled: false,
    name: 'portal_intelligence_admin',
    variationType: VariationTypes.ROLLOUT,
  },
  UPS_OAUTH_CREATE_ACCOUNT: {
    fullstoryEnabled: true,
    name: 'ups_oauth_create_account',
    variationType: VariationTypes.ROLLOUT,
  },
  USPS_OAUTH_UI: {
    fullstoryEnabled: true,
    name: 'usps_oauth_ui',
    variationType: VariationTypes.ROLLOUT,
  },
  USPS_OAUTH_UI_PARTNER_MASTER: {
    fullstoryEnabled: true,
    name: 'usps_oauth_ui_partner_master',
    variationType: VariationTypes.ROLLOUT,
  },
} as const satisfies Record<string, FeatureFlag>;

/**
 * Build a map of feature flags that are enabled for FullStory for easier access
 */
export const FullStoryFeatureFlags = Object.fromEntries(
  Object.entries(FeatureFlags as Record<string, FeatureFlag>).map(
    ([_, { fullstoryEnabled, name }]) => [name, fullstoryEnabled ?? false],
  ),
) as Record<string, boolean>;
